import * as React from "react";
import Skills from "./Skills/Skills";
import Languages from "./Languages/Languages";
import Courses from "./Courses/Courses";

class Abilities extends React.Component {
  render() {
    return (
      <div className="abilities" id="abilities">
        <div className="abilities-container">
          <div className="abilities-title">Abilities</div>
          <div className="skills-wrapper">
            <Skills />
          </div>
          <div className="courses-wrapper">
            <Courses />
          </div>
          <div className="languages-wrapper">
            <Languages />
          </div>
        </div>
      </div>
    );
  }
}

export default Abilities;
